import { extractUserSet } from "../api";
import { SqlDataTable } from "../components/SqlDataTable";
import { SqlPieChart } from "../components/SqlPieChart";
import { openExportUsersModal } from "@/components/elements/ExportUsersModal";

interface Data { name: string, value: number, tag_id: string };

const dataQuery = `
  select 
    tags.scope as name,
    count(*) as value,
    tags.id as tag_id,
  from tags
  inner join user_tags on user_tags.tag_id = tags.id
  group by scope, tags.id
  order by value desc
`;

const extractUsersQuery = `
  select user_id from user_tags where tag_id = ?
`

export function UserTagsChart() {
  return <SqlDataTable
    label="Tags by users"
    subtext="Tags used by users. (All Time)"
    width={600}
    onClick={(data: Data) => {
      let users: Set<string>;
      openExportUsersModal({
        headerContent: <>
          Includes only the users wit the <b>{data.name}</b> tag.
        </>,
        onDownload: async () => {
          users = await extractUserSet(extractUsersQuery, [data.tag_id])
        },
        beforeCsv: async (exportUsers) => {
          return exportUsers.filter(u => users.has(u.id));
        }
      })
    }}
  >{dataQuery}</SqlDataTable>
}